import { useRef, useState } from "react";
import { importAiProject } from "../store/editorStore.ts";

export function ProjectFileButton() {
  const input = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  return (
    <div className="project-file-control">
      <button type="button" className="header-button" disabled={loading} onClick={() => input.current?.click()}>
        {loading ? "Opening project…" : "Open project"}
      </button>
      <input ref={input} aria-label="Open project JSON" type="file" accept=".json,application/json" hidden
        onChange={async event => {
          const file = event.target.files?.[0];
          event.target.value = "";
          if (!file) return;
          setError(""); setLoading(true);
          try {
            if (file.size > 100 * 1024 * 1024) throw new Error("Project file must be smaller than 100 MB.");
            await importAiProject(JSON.parse(await file.text()));
          } catch (error) { setError(error instanceof Error ? error.message : String(error)); }
          finally { setLoading(false); }
        }} />
      {error && <span className="ai-error" role="alert">{error}</span>}
    </div>
  );
}
